import { render, staticRenderFns } from "./CategoriesCarousel.vue?vue&type=template&id=d987bc04&scoped=true"
import script from "./CategoriesCarousel.vue?vue&type=script&lang=js"
export * from "./CategoriesCarousel.vue?vue&type=script&lang=js"
import style0 from "./CategoriesCarousel.vue?vue&type=style&index=0&id=d987bc04&prod&lang=css"
import style1 from "./CategoriesCarousel.vue?vue&type=style&index=1&id=d987bc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987bc04",
  null
  
)

export default component.exports